import React, { useState, useEffect, useCallback, memo, useMemo } from 'react';
import config from '../../../config';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Avatar,
  Button,
  ResponsiveImage,
  FAQ,
  NamedLink,
  HorizontalScroll,
} from '../../../components';
import SectionWhatYouCanExpect from 'components/SectionWhatYouCanExpect/SectionWhatYouCanExpect';
import { FormattedMessage } from 'util/reactIntl';
import SectionUpcomingClasses from 'containers/ListingPage/SectionUpcomingClasses';
import SectionFacilities from 'containers/ListingPage/SectionFacilities';
import SectionMapMaybe from 'containers/ListingPage/SectionMapMaybe';
import ActionBarMaybe from 'containers/ListingPage/ActionBarMaybe';
import SectionBlogs from './SectionBlogs';
import SectionReviews from 'containers/ListingPage/SectionReviews';
import yellowStar from '../../../assets/CompanyPage/yellowStar.svg';
import batch from '../../../assets/CompanyPage/batch.svg';
import { init } from '@emailjs/browser';
import { GenericMessage } from 'components';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAuthorClasses,
  fetchAuthorCourses,
  fetchAuthorFacilities,
  fetchCurrentListingUserReviews,
} from '../ListingPage.duck';
import { SectionOtherAutherListing } from '../SectionOtherAutherListing';
import css from './CompanyPage.css';
import { getHtmlElementTopPosition } from 'util/htmlElements';
import moment from 'moment';
import TopFloatingMessage from 'components/TopFloatingMessage/TopFloatingMessage';
import { LISTING_TYPES } from 'util/constants';
import SectionBookingUrl from '../SectionBookingUrl';
import { SectionOtherAuthorFacilities } from '../SectionOtherAuthorFacilities';
import SectionUpcomingFacilities from '../SectionUpcomingFacilities';

const MAX_MOBILE_SCREEN_WIDTH = 550;
const DEFAULT_DATE = {
  start: moment()
    .set({ hour: 0, minute: 0, second: 0 })
    .toISOString(),
  end: moment()
    .set({ hour: 23, minute: 59, second: 59 })
    .toISOString(),
};

const CompanyPageContent = props => {
  const {
    intl,
    isOwnListing,
    currentListing,
    listingId,
    listingSlug,
    listingType,
    listingTab,
    otherAuthorsListings,
    otherAuthorsFacilitiesListings,
    authorDisplayName,
    onFetchAuthorFacilities,
    authorFacilities,
    authorFacilitiesIsLoading,
    onFetchTimeSlots,
    facilityTimeslots,
    authorClasses,
    authorClassesIsLoading,
    allListingReviews,
    onContactUser,
    viewport,
    isMainWrapperBlur,
    topbar,
    addBookingData,
    disbleListing,
    onMakeListingLive,
    isEducationSite,
    routeName,
    bookedTimeslots,
  } = props;

  const dispatch = useDispatch();
  const { allClassListingReviews, currentListingAuthorReviews } = useSelector(
    state => state.ListingPage
  );
  const [allReviews, setAllReviews] = useState([]);
  const [emailStatus, setEmailStatus] = useState(null);
  const [showAllImages, setShowAllImages] = useState(false);
  const [showQuote, setShowQuote] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const [maxDay, setMaxDay] = useState(5);

  const EMAILSTATUS_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
  };

  const topBarNavObj = {
    // aboutUs: 'About us',
    classes: 'Upcoming classes',
    // facilities: 'Facilities',
    product: 'Book A Coach',
    // socials: 'Socials',
    // facility: 'Book A Court',
    // links: 'Links',
    // faq: 'FAQ',
    // reviews: 'Reviews',
    expect: 'Expectations',
    // blogs: 'Our Blogs',
  };

  const topBarNavIds = Object.keys(topBarNavObj);
  const intialScrollClass = topBarNavIds.reduce((acc, crr) => ({ ...acc, [crr]: '' }), {});
  // { coachesId: '', academiesId: '', facilitiesId: '' };
  const [activeScrollClass, setActiveScrollClass] = useState(intialScrollClass);
  const scrollToId = eleId => {
    // const section = document.querySelector(`#${eleId}`);
    // section.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const headerOffset = 52;
    const elementPosition = getHtmlElementTopPosition(`#${eleId}`);

    if (typeof window !== 'undefined') {
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.onscroll = () => {
        setShowQuote(window.pageYOffset > 400);
      };
    }
  });

  useEffect(() => {
    init('p656r9_5pKAHF0ioU');
    if (typeof window !== 'undefined') {
      window.onscroll = () => {
        setIsScrolling(window.pageYOffset > 300);
      };
    }
  }, []);

  useEffect(() => {
    const reviews = Object.entries({ ...currentListingAuthorReviews }).reduce(
      (arr, [key, value]) => {
        return arr.concat(value);
      },
      []
    );
    const reviewsWithContent = reviews.filter(
      review => review.attributes?.content !== config.dummyReviewContent
    );
    setAllReviews(reviewsWithContent);
  }, [currentListingAuthorReviews]);

  const authorId = currentListing?.author?.id;

  useEffect(() => {
    authorId && dispatch(fetchCurrentListingUserReviews([authorId]));
  }, [authorId, dispatch]);

  useEffect(() => {
    const authorId = currentListing?.author?.id?.uuid;
    const DEFAULT_DATE = {
      start: moment()
        .set({ hour: 0, minute: 0, second: 0 })
        .toISOString(),
      end: moment()
        ?.add(7, 'd')
        ?.set({ hour: 23, minute: 59, second: 59 })
        ?.toISOString(),
    };

    if (isEducationSite) dispatch(fetchAuthorCourses(authorId, DEFAULT_DATE));
    else dispatch(fetchAuthorClasses(authorId, DEFAULT_DATE));
  }, [currentListing?.author?.id]);

  const viewportWidth = viewport?.width;

  const isMobileLayout = useMemo(() => {
    return viewportWidth ? viewportWidth < MAX_MOBILE_SCREEN_WIDTH : false;
  }, [viewportWidth]);
  const { publicData } = currentListing?.attributes;
  const {
    facebookLink,
    twitterLink,
    instagramLink,
    whatsappNumber,
    socials,
    webLink,
    linkedinLink,
  } = publicData;

  const authorAvailable = currentListing && currentListing.author;
  const currentAuthor = authorAvailable ? currentListing.author : null;

  const backgroundImage = currentListing?.images.slice(0, 1);
  const otherImages = currentListing?.images.slice(1, currentListing.images.length);
  const services = publicData.services;

  const companyAddress = publicData?.location?.address;
  const FAQData = publicData?.FAQ || [];
  const blogsData = publicData?.blogs || [];

  const getNumberOfImageDisplay = useCallback(() => {
    if (viewportWidth < 768) return 4;
    else if (viewportWidth > 1600) return 8;
    else return 4;
  }, [viewportWidth]);
  const getNumberOfProductListings = useCallback(() => {
    if (viewportWidth <= 550) return 4;
    else if (viewportWidth >= 551 && viewportWidth <= 1199) return 4;
    else if (viewportWidth >= 1200 && viewportWidth <= 1550) return 6;
    else return 12;
  }, [viewportWidth]);

  const onCloseEmailStatusMessage = () => {
    setEmailStatus(null);
  };

  const socialLogo = {
    facebook:
      'https://res.cloudinary.com/movementbuddy-pte-ltd/image/upload/v1699506094/probuddy/static/images/Icons/facebooklogo_klhivm.png',
    instagram:
      'https://res.cloudinary.com/movementbuddy-pte-ltd/image/upload/v1699506106/probuddy/static/images/Icons/instagramlogo_gfljyg.png',
    linkedin:
      'https://res.cloudinary.com/movementbuddy-pte-ltd/image/upload/v1699506128/probuddy/static/images/Icons/linkedinlogo_a1by1b.png',
    website:
      'https://res.cloudinary.com/movementbuddy-pte-ltd/image/upload/v1699506113/probuddy/static/images/Icons/websitelogo_yui1mt.png',
  };
  // const requestFormHandler = data => {
  //   try {
  //     const templateParams = {
  //       from_name: data.firstName + ' ' + data.lastName,
  //       to_name: provider_name,
  //       hearAboutUs: data.hearAboutUs,
  //       phoneNumber: data.phoneNumber,
  //       preferredLocation: data.preferredLocation,
  //       whyContacted: data.whyContacted,
  //       from_to: companyEmail,
  //     };

  //     emailjs.send('service_o59sg3q', 'template_gzihv91', templateParams, 'DkU54piL9T3fDaZV1').then(
  //       result => {
  //         setEmailStatus(EMAILSTATUS_TYPE.SUCCESS);
  //       },
  //       error => {
  //         console.log(error);
  //         setEmailStatus(EMAILSTATUS_TYPE.ERROR);
  //       }
  //     );
  //   } catch (e) {
  //     console.log('oops!.Error during mail sending', e);
  //     setEmailStatus(EMAILSTATUS_TYPE.ERROR);
  //   }
  // };
  const currentListingType = currentListing?.attributes?.publicData?.listing_type;
  const isTutor = currentListingType === 'tutor' || currentListingType === 'freelancer';
  const experience = currentListing?.attributes?.publicData?.work_experience;
  const education = currentListing?.attributes?.publicData?.education;
  const qualifications = currentListing?.attributes?.publicData?.qualifications;
  const introductoryVideo = currentListing?.attributes?.publicData?.introductoryVideo;
  const date = DEFAULT_DATE;

  const totalListing = otherAuthorsListings.length + authorClasses.length;

  useEffect(() => {
    const authorId = currentListing?.author?.id?.uuid;
    authorId && onFetchAuthorFacilities(authorId, date);
  }, [currentListing.author?.id?.uuid, date, maxDay]);

  return (
    <>
      <LayoutSingleColumn className={css.pageRoot}>
        <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.layoutWrapperTopbar}>
          <GenericMessage
            message={<FormattedMessage id="CompanyPage.emailSuccessMessage" />}
            show={emailStatus && emailStatus === EMAILSTATUS_TYPE.SUCCESS}
            onClose={onCloseEmailStatusMessage}
          />

          <GenericMessage
            message={<FormattedMessage id="CompanyPage.emailErrorMessage" />}
            show={emailStatus && emailStatus === EMAILSTATUS_TYPE.ERROR}
            onClose={onCloseEmailStatusMessage}
          />

          {isMainWrapperBlur ? <div className={css.overlayBody} /> : null}

          {/* 
          //  floating Whatsapp messages and moblie what icon
          {isMobileLayout && isScrolling && (
            <div className={css.whatsappLinkCompany}>
              <a
                href="https://wa.me/message/WHZFXEGQ6RL5H1"
                onClick={() => {
                  whatsappLinkClickTrack();
                }}
              >
                <img alt="whatsapp-link" src="https://res.cloudinary.com/movementbuddy-pte-ltd/image/upload/v1699507459/probuddy/static/images/Icons/WhatsappImg_m1f6lt.png" />
              </a>
            </div>
          )} */}

          <div className={css.actionBarWrapper}>
            {!isOwnListing && showQuote && (
              <TopFloatingMessage
                FormattedButtonText="CategoriesPage.quoteButtonText"
                className={css.floatingTopBar}
                // titleMessage={`Let us find a ${isEducationSite ? 'Tutor' : 'Coach'} for you?`}
                titleMessage={`Contact This Vendor Now`}
                lableText="Tell them what you need"
                inputText="We will reply within hours"
                onClick={onContactUser}
                isEducationSite={isEducationSite}
              />
            )}
            <ActionBarMaybe
              isOwnListing={isOwnListing}
              listing={currentListing}
              routeName={routeName}
              editParams={{
                id: listingId.uuid,
                slug: listingSlug,
                type: listingType,
                tab: listingTab,
              }}
            />
          </div>
          <div className={css.headImageContainer}>
            <ResponsiveImage
              src={backgroundImage[0]}
              image={backgroundImage[0]}
              variants={isMobileLayout ? ['square-small', 'square-small2x'] : ['landscape-crop4x']}
              alt="title"
            />
            <div
              className={classNames(css.imageContainer, {
                [css.imageContainerBackground]: !isMobileLayout,
              })}
            >
              {!!disbleListing ? (
                <button
                  className={css.goLiveBtn}
                  onClick={() => {
                    onMakeListingLive({
                      id: currentListing.id.uuid,
                      hidelisting: false,
                    });
                  }}
                >
                  <FormattedMessage id={'ListingPage.makeLive'} />
                </button>
              ) : !isMobileLayout ? (
                <span className={css.headContainer}>
                  {/* <FormattedMessage id="CompanyPage.getHealthy" /> */}
                  {currentListing.attributes.publicData.wallpaper_text}
                </span>
              ) : null}
            </div>
          </div>

          <div className={css.subMainContainer}>
            <div className={css.leftSideContainer}>
              <div className={css.leftSideContainerTop}>
                <div className={css.sectionAuthor}>
                  <Avatar className={css.authorAvatar} user={currentAuthor} disableProfileLink />
                  <h4 className={css.authorName}>{authorDisplayName}</h4>
                  <p className={css.authorAddress}>{companyAddress}</p>
                </div>
                {/* 
                // This is A Messsage Button code 
                {!isMobileLayout && (
                  <Button className={css.messageButton} onClick={onContactUser}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="18"
                      viewBox="0 0 22 18"
                      fill="none"
                    >
                      <path
                        d="M10.9974 13.334C10.3474 13.334 9.80573 13.1173 9.26406 12.9007L0.164062 7.26732V14.4173C0.164062 16.259 1.5724 17.6673 3.41406 17.6673H18.5807C20.4224 17.6673 21.8307 16.259 21.8307 14.4173V7.26732L12.7307 12.9007C12.1891 13.1173 11.6474 13.334 10.9974 13.334ZM18.5807 0.333984H3.41406C1.5724 0.333984 0.164062 1.74232 0.164062 3.58398V4.77565L10.4557 11.059C10.7807 11.2757 11.2141 11.2757 11.5391 11.059L21.8307 4.77565V3.58398C21.8307 1.74232 20.4224 0.333984 18.5807 0.333984Z"
                        fill="#0058FA"
                      />
                    </svg>
                    <span className={css.messageButtonText}>
                      <FormattedMessage id="CompanyPage.message" />
                    </span>
                  </Button>
                )} */}
                <div className={css.listingInfoWrapper}>
                  {/* <div className={css.listingInfo}>
                    <span className={css.listItem}>
                      <FormattedMessage id="CompanyPage.orderCompleted" />
                    </span>
                    <span className={css.listValue}>{totalBookings}</span>
                  </div>
                  <div className={css.listingInfo}>
                    <span className={css.listItem}>
                      <FormattedMessage id="CompanyPage.ratings" />
                    </span>
                    <span className={css.listValue}>{totalRating.toFixed(2)}</span>
                  </div> */}
                  <div className={css.listingInfo}>
                    <span className={css.listItem}>
                      <FormattedMessage id="CompanyPage.numberOfOffers" />
                    </span>
                    <span className={css.listValue}>{totalListing}</span>
                  </div>
                  {!isMobileLayout && currentListing?.author?.id.uuid && (
                    <div className={css.leftSideContainerBottom}>
                      <Button
                        className={classNames(css.yellowButton, css.exploreButton)}
                        onClick={onContactUser}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="18"
                          viewBox="0 0 22 18"
                          fill="none"
                        >
                          <path
                            d="M10.9974 13.334C10.3474 13.334 9.80573 13.1173 9.26406 12.9007L0.164062 7.26732V14.4173C0.164062 16.259 1.5724 17.6673 3.41406 17.6673H18.5807C20.4224 17.6673 21.8307 16.259 21.8307 14.4173V7.26732L12.7307 12.9007C12.1891 13.1173 11.6474 13.334 10.9974 13.334ZM18.5807 0.333984H3.41406C1.5724 0.333984 0.164062 1.74232 0.164062 3.58398V4.77565L10.4557 11.059C10.7807 11.2757 11.2141 11.2757 11.5391 11.059L21.8307 4.77565V3.58398C21.8307 1.74232 20.4224 0.333984 18.5807 0.333984Z"
                            fill="#fff"
                          />
                        </svg>
                        <span className={css.messageButtonText}>
                          <FormattedMessage id="CompanyPage.message" />
                        </span>
                      </Button>
                      {currentListingType !== LISTING_TYPES.PLAYER_PROFILE && totalListing !== 0 && (
                        <NamedLink
                          name={isEducationSite ? 'EducationVendorListings' : 'VendorListings'}
                          params={{ id: currentListing?.author?.id.uuid }}
                        >
                          <div className={css.exploreButton}>
                            <span className={css.messageButtonText}>
                              <FormattedMessage id="CompanyPage.exploreMessage" />
                            </span>
                          </div>
                        </NamedLink>
                      )}
                    </div>
                  )}
                  <div className={css.quickScroll}>
                    {Object.entries(topBarNavObj)
                      .reverse()
                      .map(([key, val]) => (
                        <div
                          onClick={() => {
                            scrollToId(key);
                          }}
                          key={key}
                          className={classNames(css.floatingWrap, activeScrollClass[key])}
                        >
                          <p className={css.floatingLink}>{val}</p>
                        </div>
                      ))}
                  </div>
                  {/* 
                  // This is the Book A session Button
                   <NamedLink name="VendorListings" params={{ id: currentListing?.author?.id.uuid }}>
                    <Button className={css.exploreButton}>
                      <span className={css.messageButtonText}>
                        <FormattedMessage id="CompanyPage.exploreMessage" />
                      </span>
                    </Button>
                  </NamedLink> */}
                </div>
                {/* {(facebookLink || instagramLink || webLink || linkedinLink) && (
                  <div className={css.socialContainer}>
                    <h6 className={css.socialHeadding}>
                      <FormattedMessage id="CompanyPage.onTheWeb" />
                    </h6>
                    <div className={css.socialIconsWrappers}>
                      {twitterLink && (
                        <span className={css.socialIcon}>
                          <a href={twitterLink}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M9.99964 0C4.48591 0 0 4.4859 0 9.99982C0 15.5139 4.48591 20 9.99964 20C15.5137 20 19.9996 15.5139 19.9996 9.99982C19.9995 4.4859 15.5136 0 9.99964 0ZM15.3218 7.39176C15.0567 7.78882 14.7269 8.1387 14.3463 8.42692C14.3479 8.48494 14.349 8.54296 14.349 8.60099C14.349 11.5172 12.1299 14.5336 8.41638 14.5336C7.28314 14.5341 6.17358 14.2092 5.21969 13.5973C5.18568 13.5756 5.16006 13.543 5.14702 13.5048C5.13398 13.4666 5.1343 13.4252 5.14792 13.3872C5.16117 13.349 5.18712 13.3165 5.22142 13.2951C5.25573 13.2738 5.29633 13.2648 5.33645 13.2697C5.49303 13.2877 5.64818 13.2967 5.79779 13.2967C6.52622 13.2967 7.22037 13.1008 7.82971 12.7266C7.46273 12.638 7.12473 12.4565 6.84825 12.1994C6.57177 11.9423 6.36612 11.6184 6.25109 11.2589C6.24168 11.2293 6.24008 11.1979 6.24647 11.1676C6.25285 11.1372 6.26699 11.1091 6.28752 11.0859C6.30804 11.0626 6.3343 11.0451 6.36369 11.0352C6.39308 11.0253 6.42456 11.0232 6.45498 11.0293C6.48855 11.0357 6.52229 11.0412 6.55586 11.0459C5.9358 10.6508 5.53356 9.95608 5.53356 9.18694V9.16142C5.53357 9.13034 5.5417 9.09981 5.55713 9.07285C5.57256 9.04588 5.59476 9.0234 5.62153 9.00764C5.64831 8.99188 5.67874 8.98338 5.70981 8.98298C5.74088 8.98259 5.77151 8.9903 5.79868 9.00537C5.87635 9.0484 5.95687 9.08572 6.03953 9.11714C5.72225 8.72501 5.54941 8.23574 5.54998 7.73134C5.54998 7.34249 5.653 6.9597 5.84778 6.62459C5.86228 6.59961 5.88262 6.57852 5.90705 6.56313C5.93149 6.54773 5.9593 6.5385 5.98809 6.53622C6.01689 6.53394 6.0458 6.53867 6.07236 6.55002C6.09892 6.56137 6.12233 6.579 6.14058 6.60138C7.09021 7.7658 8.47066 8.49833 9.95554 8.6333C9.94502 8.54484 9.93978 8.45583 9.93983 8.36675C9.93983 7.15324 10.9273 6.16593 12.141 6.16593C12.7136 6.16593 13.2676 6.39178 13.6762 6.78849C14.0756 6.69957 14.4584 6.54777 14.8101 6.33876C14.8189 6.31121 14.8342 6.2862 14.8548 6.26589C14.8754 6.24558 14.9006 6.23057 14.9282 6.22215C14.9559 6.21373 14.9852 6.21215 15.0136 6.21755C15.042 6.22295 15.0687 6.23517 15.0913 6.25315C15.1139 6.27113 15.1319 6.29435 15.1435 6.32079C15.1552 6.34723 15.1603 6.37612 15.1584 6.40497C15.1564 6.43381 15.1475 6.46175 15.1324 6.48639C15.1172 6.51102 15.0964 6.53161 15.0715 6.54639C14.9841 6.82049 14.8433 7.0746 14.6573 7.2941C14.8086 7.2484 14.9569 7.19331 15.1013 7.12914C15.1367 7.11351 15.1762 7.1098 15.2138 7.11855C15.2515 7.1273 15.2853 7.14804 15.3102 7.17766C15.335 7.20727 15.3496 7.24416 15.3517 7.28277C15.3538 7.32138 15.3433 7.35963 15.3218 7.39176Z"
                                fill="#231F20"
                              />
                            </svg>
                          </a>
                        </span>
                      )}
                      {facebookLink && (
                        <span className={css.socialIcon}>
                          <a href={facebookLink}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M9.9999 0C4.48576 0 0 4.4859 0 9.99982C0 15.5139 4.48576 20 9.9999 20C15.5137 20 19.9998 15.5139 19.9998 9.99982C19.9998 4.4859 15.5137 0 9.9999 0ZM12.8262 6.31269C12.8262 6.36004 12.8073 6.40545 12.7739 6.43893C12.7404 6.47242 12.695 6.49123 12.6476 6.49123L11.5109 6.49194C10.7608 6.49194 10.6237 6.78402 10.6237 7.35927V8.55261H12.5733C12.6246 8.55261 12.6735 8.57474 12.7072 8.61331C12.741 8.65187 12.7567 8.70311 12.7505 8.75399L12.4728 10.9023C12.4673 10.9454 12.4462 10.9849 12.4136 11.0136C12.381 11.0422 12.3391 11.058 12.2957 11.058H10.6237V16.3925C10.6237 16.4398 10.6049 16.4853 10.5714 16.5187C10.5379 16.5522 10.4925 16.571 10.4452 16.571H8.22702C8.17967 16.571 8.13426 16.5522 8.10077 16.5187C8.06729 16.4853 8.04848 16.4398 8.04848 16.3925V11.058H6.37112C6.32377 11.058 6.27836 11.0392 6.24487 11.0057C6.21139 10.9722 6.19258 10.9268 6.19258 10.8795V8.73114C6.19258 8.68379 6.21139 8.63838 6.24487 8.6049C6.27836 8.57142 6.32377 8.55261 6.37112 8.55261H8.04848V7.14663C8.04848 5.2845 9.17541 4.12794 10.9899 4.12794C11.7699 4.12794 12.4593 4.18596 12.671 4.21399C12.7139 4.21966 12.7533 4.24073 12.7819 4.27328C12.8104 4.30583 12.8261 4.34764 12.8262 4.39092V6.31269Z"
                                fill="#231F20"
                              />
                            </svg>
                          </a>
                        </span>
                      )}
                      {instagramLink && (
                        <span className={css.socialIcon}>
                          <a href={instagramLink}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M14.0578 6.92747C13.971 6.70273 13.8382 6.49866 13.6677 6.3284C13.4973 6.15814 13.2931 6.02547 13.0682 5.93893C12.7586 5.82427 12.4317 5.76367 12.1016 5.75977C11.5526 5.73477 11.388 5.72852 9.9974 5.72852C8.60677 5.72852 8.44219 5.73477 7.89323 5.75977C7.56277 5.76355 7.23543 5.82415 6.92552 5.93893C6.70078 6.02571 6.49671 6.15859 6.32645 6.32903C6.15619 6.49947 6.02352 6.70368 5.93698 6.92852C5.82232 7.23809 5.76171 7.56507 5.75781 7.89518C5.73281 8.44414 5.72656 8.60872 5.72656 9.99935C5.72656 11.39 5.73281 11.5546 5.75781 12.1035C5.76159 12.434 5.8222 12.7613 5.93698 13.0712C6.02375 13.296 6.15664 13.5 6.32708 13.6703C6.49752 13.8406 6.70173 13.9732 6.92656 14.0598C7.23614 14.1744 7.56312 14.235 7.89323 14.2389C8.44219 14.2639 8.60677 14.2702 9.9974 14.2702C11.388 14.2702 11.5526 14.2639 12.1016 14.2389C12.432 14.2351 12.7594 14.1745 13.0693 14.0598C13.294 13.973 13.4981 13.8401 13.6683 13.6697C13.8386 13.4992 13.9713 13.295 14.0578 13.0702C14.1725 12.7606 14.2331 12.4336 14.237 12.1035C14.262 11.5546 14.2682 11.39 14.2682 9.99935C14.2682 8.60872 14.262 8.44414 14.237 7.89518C14.2332 7.56472 14.1726 7.23738 14.0578 6.92747ZM9.9974 12.6743C9.46833 12.6743 8.95115 12.5175 8.51124 12.2235C8.07134 11.9296 7.72848 11.5118 7.52602 11.023C7.32355 10.5342 7.27058 9.99638 7.37379 9.47748C7.47701 8.95858 7.73178 8.48194 8.10588 8.10784C8.47999 7.73373 8.95663 7.47896 9.47553 7.37575C9.99443 7.27253 10.5323 7.32551 11.0211 7.52797C11.5099 7.73044 11.9276 8.0733 12.2216 8.5132C12.5155 8.9531 12.6724 9.47028 12.6724 9.99935C12.6724 10.7088 12.3906 11.3892 11.8889 11.8909C11.3872 12.3925 10.7068 12.6743 9.9974 12.6743ZM12.7776 7.84414C12.654 7.84414 12.5332 7.80748 12.4304 7.73881C12.3276 7.67013 12.2475 7.57252 12.2002 7.45832C12.1529 7.34411 12.1405 7.21845 12.1646 7.09721C12.1887 6.97597 12.2483 6.86461 12.3357 6.7772C12.4231 6.68979 12.5344 6.63027 12.6557 6.60615C12.7769 6.58203 12.9026 6.59441 13.0168 6.64172C13.131 6.68902 13.2286 6.76913 13.2973 6.87191C13.3659 6.97469 13.4026 7.09553 13.4026 7.21914C13.4026 7.3849 13.3368 7.54387 13.2195 7.66108C13.1023 7.77829 12.9434 7.84414 12.7776 7.84414Z"
                                fill="black"
                              />
                              <path
                                d="M10.0021 11.7366C10.9611 11.7366 11.7385 10.9591 11.7385 10.0001C11.7385 9.04111 10.9611 8.26367 10.0021 8.26367C9.04306 8.26367 8.26562 9.04111 8.26562 10.0001C8.26562 10.9591 9.04306 11.7366 10.0021 11.7366Z"
                                fill="black"
                              />
                              <path
                                d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433282 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17316C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761204C12.6136 0.258658 11.3132 0 10 0ZM15.1771 12.1479C15.1681 12.5798 15.0861 13.007 14.9344 13.4115C14.8006 13.7574 14.596 14.0715 14.3338 14.3338C14.0715 14.596 13.7574 14.8006 13.4115 14.9344C13.007 15.0861 12.5798 15.1681 12.1479 15.1771C11.5917 15.2021 11.4146 15.2083 10 15.2083C8.58542 15.2083 8.40834 15.2021 7.85209 15.1771C7.42022 15.1681 6.99299 15.0861 6.58854 14.9344C6.24263 14.8006 5.92848 14.596 5.66623 14.3338C5.40397 14.0715 5.1994 13.7574 5.06563 13.4115C4.91392 13.007 4.83186 12.5798 4.82292 12.1479C4.79792 11.5917 4.79167 11.4146 4.79167 10C4.79167 8.58541 4.79792 8.40833 4.82292 7.85208C4.83186 7.42021 4.91392 6.99298 5.06563 6.58854C5.1994 6.24262 5.40397 5.92847 5.66623 5.66622C5.92848 5.40397 6.24263 5.1994 6.58854 5.06562C6.99299 4.91392 7.42022 4.83185 7.85209 4.82292C8.40834 4.79792 8.58542 4.79167 10 4.79167C11.4146 4.79167 11.5917 4.79792 12.1479 4.82292C12.5798 4.83185 13.007 4.91392 13.4115 5.06562C13.7574 5.1994 14.0715 5.40397 14.3338 5.66622C14.596 5.92847 14.8006 6.24262 14.9344 6.58854C15.0861 6.99298 15.1681 7.42021 15.1771 7.85208C15.2021 8.40833 15.2083 8.58541 15.2083 10C15.2083 11.4146 15.2021 11.5917 15.1771 12.1479Z"
                                fill="black"
                              />
                            </svg>
                          </a>
                        </span>
                      )}
                      {linkedinLink && (
                        <span className={css.socialIcon}>
                          <a href={linkedinLink}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M14.0578 6.92747C13.971 6.70273 13.8382 6.49866 13.6677 6.3284C13.4973 6.15814 13.2931 6.02547 13.0682 5.93893C12.7586 5.82427 12.4317 5.76367 12.1016 5.75977C11.5526 5.73477 11.388 5.72852 9.9974 5.72852C8.60677 5.72852 8.44219 5.73477 7.89323 5.75977C7.56277 5.76355 7.23543 5.82415 6.92552 5.93893C6.70078 6.02571 6.49671 6.15859 6.32645 6.32903C6.15619 6.49947 6.02352 6.70368 5.93698 6.92852C5.82232 7.23809 5.76171 7.56507 5.75781 7.89518C5.73281 8.44414 5.72656 8.60872 5.72656 9.99935C5.72656 11.39 5.73281 11.5546 5.75781 12.1035C5.76159 12.434 5.8222 12.7613 5.93698 13.0712C6.02375 13.296 6.15664 13.5 6.32708 13.6703C6.49752 13.8406 6.70173 13.9732 6.92656 14.0598C7.23614 14.1744 7.56312 14.235 7.89323 14.2389C8.44219 14.2639 8.60677 14.2702 9.9974 14.2702C11.388 14.2702 11.5526 14.2639 12.1016 14.2389C12.432 14.2351 12.7594 14.1745 13.0693 14.0598C13.294 13.973 13.4981 13.8401 13.6683 13.6697C13.8386 13.4992 13.9713 13.295 14.0578 13.0702C14.1725 12.7606 14.2331 12.4336 14.237 12.1035C14.262 11.5546 14.2682 11.39 14.2682 9.99935C14.2682 8.60872 14.262 8.44414 14.237 7.89518C14.2332 7.56472 14.1726 7.23738 14.0578 6.92747ZM9.9974 12.6743C9.46833 12.6743 8.95115 12.5175 8.51124 12.2235C8.07134 11.9296 7.72848 11.5118 7.52602 11.023C7.32355 10.5342 7.27058 9.99638 7.37379 9.47748C7.47701 8.95858 7.73178 8.48194 8.10588 8.10784C8.47999 7.73373 8.95663 7.47896 9.47553 7.37575C9.99443 7.27253 10.5323 7.32551 11.0211 7.52797C11.5099 7.73044 11.9276 8.0733 12.2216 8.5132C12.5155 8.9531 12.6724 9.47028 12.6724 9.99935C12.6724 10.7088 12.3906 11.3892 11.8889 11.8909C11.3872 12.3925 10.7068 12.6743 9.9974 12.6743ZM12.7776 7.84414C12.654 7.84414 12.5332 7.80748 12.4304 7.73881C12.3276 7.67013 12.2475 7.57252 12.2002 7.45832C12.1529 7.34411 12.1405 7.21845 12.1646 7.09721C12.1887 6.97597 12.2483 6.86461 12.3357 6.7772C12.4231 6.68979 12.5344 6.63027 12.6557 6.60615C12.7769 6.58203 12.9026 6.59441 13.0168 6.64172C13.131 6.68902 13.2286 6.76913 13.2973 6.87191C13.3659 6.97469 13.4026 7.09553 13.4026 7.21914C13.4026 7.3849 13.3368 7.54387 13.2195 7.66108C13.1023 7.77829 12.9434 7.84414 12.7776 7.84414Z"
                                fill="black"
                              />
                              <path
                                d="M10.0021 11.7366C10.9611 11.7366 11.7385 10.9591 11.7385 10.0001C11.7385 9.04111 10.9611 8.26367 10.0021 8.26367C9.04306 8.26367 8.26562 9.04111 8.26562 10.0001C8.26562 10.9591 9.04306 11.7366 10.0021 11.7366Z"
                                fill="black"
                              />
                              <path
                                d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433282 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17316C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761204C12.6136 0.258658 11.3132 0 10 0ZM15.1771 12.1479C15.1681 12.5798 15.0861 13.007 14.9344 13.4115C14.8006 13.7574 14.596 14.0715 14.3338 14.3338C14.0715 14.596 13.7574 14.8006 13.4115 14.9344C13.007 15.0861 12.5798 15.1681 12.1479 15.1771C11.5917 15.2021 11.4146 15.2083 10 15.2083C8.58542 15.2083 8.40834 15.2021 7.85209 15.1771C7.42022 15.1681 6.99299 15.0861 6.58854 14.9344C6.24263 14.8006 5.92848 14.596 5.66623 14.3338C5.40397 14.0715 5.1994 13.7574 5.06563 13.4115C4.91392 13.007 4.83186 12.5798 4.82292 12.1479C4.79792 11.5917 4.79167 11.4146 4.79167 10C4.79167 8.58541 4.79792 8.40833 4.82292 7.85208C4.83186 7.42021 4.91392 6.99298 5.06563 6.58854C5.1994 6.24262 5.40397 5.92847 5.66623 5.66622C5.92848 5.40397 6.24263 5.1994 6.58854 5.06562C6.99299 4.91392 7.42022 4.83185 7.85209 4.82292C8.40834 4.79792 8.58542 4.79167 10 4.79167C11.4146 4.79167 11.5917 4.79792 12.1479 4.82292C12.5798 4.83185 13.007 4.91392 13.4115 5.06562C13.7574 5.1994 14.0715 5.40397 14.3338 5.66622C14.596 5.92847 14.8006 6.24262 14.9344 6.58854C15.0861 6.99298 15.1681 7.42021 15.1771 7.85208C15.2021 8.40833 15.2083 8.58541 15.2083 10C15.2083 11.4146 15.2021 11.5917 15.1771 12.1479Z"
                                fill="black"
                              />
                            </svg>
                          </a>
                        </span>
                      )}
                      {webLink && (
                        <span className={css.socialIcon}>
                          <a href={webLink}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M14.0578 6.92747C13.971 6.70273 13.8382 6.49866 13.6677 6.3284C13.4973 6.15814 13.2931 6.02547 13.0682 5.93893C12.7586 5.82427 12.4317 5.76367 12.1016 5.75977C11.5526 5.73477 11.388 5.72852 9.9974 5.72852C8.60677 5.72852 8.44219 5.73477 7.89323 5.75977C7.56277 5.76355 7.23543 5.82415 6.92552 5.93893C6.70078 6.02571 6.49671 6.15859 6.32645 6.32903C6.15619 6.49947 6.02352 6.70368 5.93698 6.92852C5.82232 7.23809 5.76171 7.56507 5.75781 7.89518C5.73281 8.44414 5.72656 8.60872 5.72656 9.99935C5.72656 11.39 5.73281 11.5546 5.75781 12.1035C5.76159 12.434 5.8222 12.7613 5.93698 13.0712C6.02375 13.296 6.15664 13.5 6.32708 13.6703C6.49752 13.8406 6.70173 13.9732 6.92656 14.0598C7.23614 14.1744 7.56312 14.235 7.89323 14.2389C8.44219 14.2639 8.60677 14.2702 9.9974 14.2702C11.388 14.2702 11.5526 14.2639 12.1016 14.2389C12.432 14.2351 12.7594 14.1745 13.0693 14.0598C13.294 13.973 13.4981 13.8401 13.6683 13.6697C13.8386 13.4992 13.9713 13.295 14.0578 13.0702C14.1725 12.7606 14.2331 12.4336 14.237 12.1035C14.262 11.5546 14.2682 11.39 14.2682 9.99935C14.2682 8.60872 14.262 8.44414 14.237 7.89518C14.2332 7.56472 14.1726 7.23738 14.0578 6.92747ZM9.9974 12.6743C9.46833 12.6743 8.95115 12.5175 8.51124 12.2235C8.07134 11.9296 7.72848 11.5118 7.52602 11.023C7.32355 10.5342 7.27058 9.99638 7.37379 9.47748C7.47701 8.95858 7.73178 8.48194 8.10588 8.10784C8.47999 7.73373 8.95663 7.47896 9.47553 7.37575C9.99443 7.27253 10.5323 7.32551 11.0211 7.52797C11.5099 7.73044 11.9276 8.0733 12.2216 8.5132C12.5155 8.9531 12.6724 9.47028 12.6724 9.99935C12.6724 10.7088 12.3906 11.3892 11.8889 11.8909C11.3872 12.3925 10.7068 12.6743 9.9974 12.6743ZM12.7776 7.84414C12.654 7.84414 12.5332 7.80748 12.4304 7.73881C12.3276 7.67013 12.2475 7.57252 12.2002 7.45832C12.1529 7.34411 12.1405 7.21845 12.1646 7.09721C12.1887 6.97597 12.2483 6.86461 12.3357 6.7772C12.4231 6.68979 12.5344 6.63027 12.6557 6.60615C12.7769 6.58203 12.9026 6.59441 13.0168 6.64172C13.131 6.68902 13.2286 6.76913 13.2973 6.87191C13.3659 6.97469 13.4026 7.09553 13.4026 7.21914C13.4026 7.3849 13.3368 7.54387 13.2195 7.66108C13.1023 7.77829 12.9434 7.84414 12.7776 7.84414Z"
                                fill="black"
                              />
                              <path
                                d="M10.0021 11.7366C10.9611 11.7366 11.7385 10.9591 11.7385 10.0001C11.7385 9.04111 10.9611 8.26367 10.0021 8.26367C9.04306 8.26367 8.26562 9.04111 8.26562 10.0001C8.26562 10.9591 9.04306 11.7366 10.0021 11.7366Z"
                                fill="black"
                              />
                              <path
                                d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433282 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17316C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761204C12.6136 0.258658 11.3132 0 10 0ZM15.1771 12.1479C15.1681 12.5798 15.0861 13.007 14.9344 13.4115C14.8006 13.7574 14.596 14.0715 14.3338 14.3338C14.0715 14.596 13.7574 14.8006 13.4115 14.9344C13.007 15.0861 12.5798 15.1681 12.1479 15.1771C11.5917 15.2021 11.4146 15.2083 10 15.2083C8.58542 15.2083 8.40834 15.2021 7.85209 15.1771C7.42022 15.1681 6.99299 15.0861 6.58854 14.9344C6.24263 14.8006 5.92848 14.596 5.66623 14.3338C5.40397 14.0715 5.1994 13.7574 5.06563 13.4115C4.91392 13.007 4.83186 12.5798 4.82292 12.1479C4.79792 11.5917 4.79167 11.4146 4.79167 10C4.79167 8.58541 4.79792 8.40833 4.82292 7.85208C4.83186 7.42021 4.91392 6.99298 5.06563 6.58854C5.1994 6.24262 5.40397 5.92847 5.66623 5.66622C5.92848 5.40397 6.24263 5.1994 6.58854 5.06562C6.99299 4.91392 7.42022 4.83185 7.85209 4.82292C8.40834 4.79792 8.58542 4.79167 10 4.79167C11.4146 4.79167 11.5917 4.79792 12.1479 4.82292C12.5798 4.83185 13.007 4.91392 13.4115 5.06562C13.7574 5.1994 14.0715 5.40397 14.3338 5.66622C14.596 5.92847 14.8006 6.24262 14.9344 6.58854C15.0861 6.99298 15.1681 7.42021 15.1771 7.85208C15.2021 8.40833 15.2083 8.58541 15.2083 10C15.2083 11.4146 15.2021 11.5917 15.1771 12.1479Z"
                                fill="black"
                              />
                            </svg>
                          </a>
                        </span>
                      )}
                      {whatsappNumber && (
                        <span className={css.socialIcon}>
                          <a href={`https://wa.me/${whatsappNumber}`}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M10.1813 0C4.75915 0 0.363125 4.36165 0.363125 9.7425C0.363125 11.5831 0.877946 13.3046 1.77201 14.7732L0 20L5.43589 18.2731C6.8425 19.0448 8.46022 19.485 10.1813 19.485C15.6042 19.485 20 15.1227 20 9.7425C20 4.36165 15.6042 0 10.1813 0ZM15.0636 13.4424C14.8326 14.015 13.7879 14.5376 13.327 14.5617C12.8666 14.5861 12.8534 14.9186 10.3431 13.828C7.83304 12.7372 6.3229 10.085 6.20384 9.9142C6.08469 9.74402 5.23152 8.52817 5.27754 7.3046C5.32388 6.0808 5.99393 5.50344 6.23308 5.2633C6.47196 5.02281 6.74585 4.97973 6.91308 4.97701C7.11076 4.97379 7.23879 4.97112 7.38509 4.97652C7.53125 4.98205 7.7508 4.94594 7.94089 5.45147C8.13089 5.95696 8.58567 7.19938 8.64384 7.32598C8.70196 7.45272 8.73795 7.59946 8.64839 7.76219C8.55857 7.92527 8.51259 8.02714 8.38228 8.16768C8.25125 8.30821 8.10665 8.48205 7.98978 8.58951C7.85942 8.70848 7.72326 8.83826 7.86031 9.09259C7.99728 9.34674 8.46982 10.1799 9.18973 10.8665C10.115 11.7492 10.9129 12.0419 11.1584 12.1753C11.4046 12.3094 11.5515 12.2945 11.7042 12.1338C11.8562 11.9732 12.3577 11.4309 12.5344 11.1888C12.7109 10.946 12.8764 10.9936 13.1032 11.0848C13.3299 11.1764 14.5388 11.8239 14.785 11.9576C15.031 12.0911 15.1954 12.1598 15.2542 12.2657C15.313 12.3719 15.2945 12.8697 15.0636 13.4424V13.4424Z"
                                fill="black"
                              />
                            </svg>
                          </a>
                        </span>
                      )}
                    </div>
                  </div>
                )} */}
                {/* 
                // this is About A Compamy code
                <div className={css.aboutContainer}>
              <h6 className={css.aboutHeadding}>
                <FormattedMessage id="CompanyPage.about" />
              </h6>
              <p className={css.aboutText}>
                {currentListing && currentListing.attributes.description}
              </p>
            </div> */}
              </div>
              {/* {!isMobileLayout && currentListing?.author?.id.uuid && (
                <div className={css.leftSideContainerBottom}>
                  <Button
                    className={classNames(css.yellowButton, css.exploreButton)}
                    onClick={onContactUser}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="18"
                      viewBox="0 0 22 18"
                      fill="none"
                    >
                      <path
                        d="M10.9974 13.334C10.3474 13.334 9.80573 13.1173 9.26406 12.9007L0.164062 7.26732V14.4173C0.164062 16.259 1.5724 17.6673 3.41406 17.6673H18.5807C20.4224 17.6673 21.8307 16.259 21.8307 14.4173V7.26732L12.7307 12.9007C12.1891 13.1173 11.6474 13.334 10.9974 13.334ZM18.5807 0.333984H3.41406C1.5724 0.333984 0.164062 1.74232 0.164062 3.58398V4.77565L10.4557 11.059C10.7807 11.2757 11.2141 11.2757 11.5391 11.059L21.8307 4.77565V3.58398C21.8307 1.74232 20.4224 0.333984 18.5807 0.333984Z"
                        fill="#fff"
                      />
                    </svg>
                    <span className={css.messageButtonText}>
                      <FormattedMessage id="CompanyPage.message" />
                    </span>
                  </Button>
                  {currentListingType !== LISTING_TYPES.PLAYER_PROFILE && totalListing !== 0 && (
                    <NamedLink
                      name={isEducationSite ? 'EducationVendorListings' : 'VendorListings'}
                      params={{ id: currentListing?.author?.id.uuid }}
                    >
                      <div className={css.exploreButton}>
                        <span className={css.messageButtonText}>
                          <FormattedMessage id="CompanyPage.exploreMessage" />
                        </span>
                      </div>
                    </NamedLink>
                  )}
                </div>
              )} */}
            </div>

            <div id="gallery" className={css.rightSideContainer}>
              <div className={css.breadCrumbWrapper}>
                <NamedLink name={isEducationSite ? 'EducationPage' : 'HomePage'}>Home</NamedLink>
                <span className={css.breadcrumbArrow}>&gt;</span>
                <NamedLink
                  name="ListingPage"
                  params={{ id: listingId.uuid, slug: listingSlug }}
                  className={css.currentListingTypeName}
                >
                  {currentListingType}
                </NamedLink>
              </div>
              {!!otherImages.length && (
                <div className={css.sectionGallery}>
                  <div className={css.galleryWrapper}>
                    {otherImages &&
                      otherImages
                        .slice(0, showAllImages ? otherImages.length : getNumberOfImageDisplay())
                        .map((image, i) => {
                          return (
                            <div key={i} className={css.gallerItems}>
                              <ResponsiveImage
                                className={css.itemImg}
                                src={image}
                                image={image}
                                variants={['scaled-medium', 'scaled-large']}
                                alt={'title'}
                              />
                            </div>
                          );
                        })}
                  </div>
                  {otherImages.length > getNumberOfImageDisplay() && (
                    <div className={css.galleryButton}>
                      <Button onClick={() => setShowAllImages(prevState => !prevState)}>{`${showAllImages ? 'View Less' : 'View More'
                        }`}</Button>
                    </div>
                  )}
                </div>
              )}

              {currentListing && currentListing.attributes.description && (
                <div id="aboutUs">
                  <h4 className={css.upcomingTitle}>{isTutor ? 'About Me' : 'About Us'}</h4>
                  <div className={css.aboutUsWrapper}>
                    <div className={css.reviewWrap}>
                      <img src={batch} alt="batch" />
                      <img src={yellowStar} alt={'star'} />
                      <div>{isTutor ? 'About Me' : 'About Us'}</div>
                    </div>
                    <div className={css.description}>
                      {currentListing && currentListing.attributes.description}
                    </div>
                  </div>
                </div>
              )}
              {console.log('reyterytuerytui',authorFacilities)}
              {!isEducationSite && currentAuthor && !!authorFacilities?.length && (
                <div id="facilities">
                  <h4 className={css.upcomingTitle}>Court Bookings</h4>

                  <div
                    className={classNames(css.facilityContainer, {
                      [css.facilityTop]: !authorFacilities?.length,
                    })}
                  >
                    <SectionFacilities
                      listing={currentListing}
                      onFetchAuthorFacilities={onFetchAuthorFacilities}
                      authorFacilities={authorFacilities}
                      authorFacilitiesIsLoading={authorFacilitiesIsLoading}
                      onFetchTimeSlots={onFetchTimeSlots}
                      facilityTimeslots={facilityTimeslots}
                      bookedTimeslots={bookedTimeslots}
                      intl={intl}
                      addBookingData={addBookingData}
                      isMobileLayout={isMobileLayout}
                      setMaxDay={setMaxDay}
                      maxDay={maxDay}
                    />
                  </div>
                </div>
              )}
              {/* {currentListingType !== LISTING_TYPES.PLAYER_PROFILE &&
                currentAuthor &&
                !!authorFacilities?.length && (
                  <div id="facility">
                    <h4 className={css.upcomingTitle}>Book A Court</h4>
                    <div className={css.classesContainer}>
                      <SectionUpcomingFacilities
                        listing={currentListing}
                        fetchAuthorFacilities={(authorId, date) => {
                          dispatch(fetchAuthorFacilities(authorId, date));
                        }}
                        authorFacilities={authorFacilities}
                        authorFacilitiesIsLoading={authorFacilitiesIsLoading}
                        allClassListingReviews={allClassListingReviews}
                        isEducationSite={isEducationSite}
                      />
                    </div>
                  </div>
                )} */}
              {!!introductoryVideo && (
                <div id="introductoryVideo">
                  <div className={css.aboutUsWrapper}>
                    <div className={css.reviewWrap}>
                      <img src={batch} alt="batch" />
                      <img src={yellowStar} alt={'star'} />
                      <div>{'Introductory Video'}</div>
                    </div>
                    <div className={css.description}>
                      <video
                        id="my-video"
                        // class="video-js vjs-big-play-centered vjs-theme-sea"
                        src={introductoryVideo}
                        controls
                        loop
                        autoPlay
                        muted
                        playsInline
                        width="100%"
                        data-setup="{}"
                        className={css.introVideo}
                      >
                        <source
                          src={introductoryVideo}
                          type="video/mp4"
                        // type={`video/${getExtensionFromUrl(introductoryVideo)}`}
                        />
                      </video>
                    </div>
                  </div>
                </div>
              )}

              {!!education && (
                <div id="education" className={css.mainWrapper}>
                  <div className={css.aboutUsWrapperEdu}>
                    <div className={css.reviewWrap}>
                      <img src={batch} alt="batch" />
                      <img src={yellowStar} alt={'star'} />
                      {/* <h4 className={css.upcomingTitle}>Education</h4> */}
                      <div>Education</div>
                    </div>
                    <div className={css.description}>{education}</div>
                  </div>
                </div>
              )}

              {!!experience && (
                <div id="experience" className={css.mainWrapper}>
                  <div className={css.aboutUsWrapperEdu}>
                    <div className={css.reviewWrap}>
                      <img src={batch} alt="batch" />
                      <img src={yellowStar} alt={'star'} />
                      {/* <h4 className={css.upcomingTitle}>Work Experience</h4> */}
                      <div> Work Experience</div>
                    </div>
                    <div className={css.description}>{experience}</div>
                  </div>
                </div>
              )}

              {!!qualifications && (
                <div id="qualifications" className={css.mainWrapper}>
                  <div className={css.aboutUsWrapperEdu}>
                    <div className={css.reviewWrap}>
                      <img src={batch} alt="batch" />
                      <img src={yellowStar} alt={'star'} />
                      {/* <h4 className={css.upcomingTitle}>Qualifications</h4> */}
                      <div> Qualifications</div>
                    </div>
                    <div className={css.description}>{qualifications}</div>
                  </div>
                </div>
              )}

              {currentAuthor && !!authorClasses?.length && (
                <div id="classes">
                  <h4 className={css.upcomingTitle}>Upcoming Classes</h4>
                  <div className={css.classesContainer}>
                    <SectionUpcomingClasses
                      listing={currentListing}
                      fetchAuthorClasses={(authorId, date) => {
                        isEducationSite
                          ? dispatch(fetchAuthorCourses(authorId, date))
                          : dispatch(fetchAuthorClasses(authorId, date));
                      }}
                      authorClasses={authorClasses}
                      authorClassesIsLoading={authorClassesIsLoading}
                      allClassListingReviews={allClassListingReviews}
                      isEducationSite={isEducationSite}
                    />
                  </div>
                </div>
              )}
              {services &&
                services.length !== 0 &&
                (currentListingType === LISTING_TYPES.COMPANY ||
                  currentListingType === LISTING_TYPES.FREELANCER) && (
                  <div id="links">
                    <h4 className={css.upcomingTitle}>Links</h4>
                    <SectionBookingUrl services={services} />
                  </div>
                )}
              {currentListingType !== LISTING_TYPES.PLAYER_PROFILE && (
                <>
                  <SectionOtherAutherListing
                    authorId={authorId}
                    isEducationSite={isEducationSite}
                    otherAuthorsListings={otherAuthorsListings}
                    getNumberOfProductListings={getNumberOfProductListings}
                    intl={intl}
                    allListingReviews={allListingReviews}
                    viewport={viewport}
                  />
                  {/* <SectionOtherAuthorFacilities
                    authorId={authorId}
                    isEducationSite={isEducationSite}
                    otherAuthorsFacilitiesListings={otherAuthorsFacilitiesListings} // end
                    getNumberOfProductListings={getNumberOfProductListings}
                    intl={intl}
                    allListingReviews={allListingReviews}
                    viewport={viewport}
                  /> */}
                </>
              )}
              {socials &&
                socials.length !== 0 &&
                (currentListingType === LISTING_TYPES.COMPANY ||
                  currentListingType === LISTING_TYPES.FREELANCER) && (
                  <div id="socials">
                    <h4 className={css.upcomingTitle}>Socials</h4>
                    <div className={css.sectionSocialGallery}>
                      <div className={`${css.gallerySocialWrapper} ${css.socialGalleryWrap}`}>
                        {/* {twitterLink && (
                          <a href={twitterLink}>
                            <img src={twitter} className={css.socialMediaImg} />
                          </a>
                        )} */}
                        {/* <HorizontalScroll
                          className={css.horizontalScroll}
                          scrollClassName={css.scrollControl}
                        > */}
                        {socials.map((social, i) => {
                          return (
                            <a key={i} className={css.socialMain} href={social?.url}>
                              <img
                                src={social?.asset?.url}
                                alt={social.social}
                                className={css.socialMediaImg}
                              />
                              <div className={css.socialmain}>
                                <div className={css.socialInfo}>
                                  <img
                                    className={css.socialLogo}
                                    src={socialLogo[social.social]}
                                    alt={social.social}
                                  />
                                  <h3 className={css.socialText}>{social.social}</h3>
                                </div>
                              </div>
                            </a>
                          );
                        })}
                        {/* </HorizontalScroll> */}
                        {/* {socials && (
                          <a className={css.socialMain} href={socials[0].url}>
                            <img src={socials[0].asset.url} className={css.socialMediaImg} />
                          </a>
                        )}
                        {socials && (
                          <a className={css.socialMain} href={socials[0].url}>
                            <img src={socials[0].asset.url} className={css.socialMediaImg} />
                          </a>
                        )}
                        {socials && (
                          <a className={css.socialMain} href={socials[0].url}>
                            <img src={socials[0].asset.url} className={css.socialMediaImg} />
                          </a>
                        )} */}
                      </div>
                    </div>
                  </div>
                )}
              {FAQData && FAQData.length > 0 && (
                <div id="faq" className={css.sectionFAQWrapper}>
                  <h2 className={css.sectionFAQTitle}>
                    <FormattedMessage id="CompanyPage.FAQTitle" />
                  </h2>
                  <FAQ data={FAQData} />
                </div>
              )}

              <SectionMapMaybe
                geolocation={currentListing.attributes.geolocation}
                publicData={publicData}
                rootClassName={css.mapImage}
                isStatic={false}
                listingId={currentListing.id}
              />

              {currentListingType !== LISTING_TYPES.PLAYER_PROFILE &&
                allReviews &&
                !!allReviews.length && (
                  <div id="reviews">
                    <h4 className={css.reviewTitle}>
                      <FormattedMessage id="CompanyPage.reviews" />
                    </h4>
                    <SectionReviews reviews={allReviews} />
                  </div>
                )}
              {blogsData && blogsData.length > 0 && (
                <div id="blogs">
                  <h4 className={css.blogTitle}>
                    <FormattedMessage id="CompanyPage.ourBlogs" />
                  </h4>
                  <SectionBlogs viewport={viewport} blogs={blogsData} />
                </div>
              )}

              {publicData.expectations && publicData.expectations.length > 0 && (
                <div id="expect">
                  <div className={css.sectionWhatYouCanExpectWrapper}>
                    <SectionWhatYouCanExpect data={publicData.expectations} />
                  </div>
                </div>
              )}

              {/* {!isEducationSite && (
                <div>
                  <h4 className={css.sendRequestTitle}>
                    <FormattedMessage id="CompanyPage.sendYourRequest" />
                  </h4>
                  <SendRequestForm
                    onSubmit={requestFormHandler}
                    isEducationSite={isEducationSite}
                  />
                </div>
              )} */}
            </div>
            {isMobileLayout && (
              <div className={css.leftSideContainerBottom}>
                <Button
                  className={classNames(css.exploreButton, css.yellowButton)}
                  onClick={onContactUser}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="18"
                    viewBox="0 0 22 18"
                    fill="none"
                  >
                    <path
                      d="M10.9974 13.334C10.3474 13.334 9.80573 13.1173 9.26406 12.9007L0.164062 7.26732V14.4173C0.164062 16.259 1.5724 17.6673 3.41406 17.6673H18.5807C20.4224 17.6673 21.8307 16.259 21.8307 14.4173V7.26732L12.7307 12.9007C12.1891 13.1173 11.6474 13.334 10.9974 13.334ZM18.5807 0.333984H3.41406C1.5724 0.333984 0.164062 1.74232 0.164062 3.58398V4.77565L10.4557 11.059C10.7807 11.2757 11.2141 11.2757 11.5391 11.059L21.8307 4.77565V3.58398C21.8307 1.74232 20.4224 0.333984 18.5807 0.333984Z"
                      fill="#fff"
                    />
                  </svg>
                  <span className={css.messageButtonText}>
                    <FormattedMessage id="CompanyPage.message" />
                  </span>
                </Button>
                {currentListingType !== LISTING_TYPES.PLAYER_PROFILE && (
                  <NamedLink
                    name={isEducationSite ? 'EducationVendorListings' : 'VendorListings'}
                    params={{ id: currentListing?.author?.id.uuid }}
                  >
                    <div className={css.exploreButton}>
                      <span className={css.messageButtonText}>
                        <FormattedMessage id="CompanyPage.exploreMessage" />
                      </span>
                    </div>
                  </NamedLink>
                )}
              </div>
            )}
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          {!isMobileLayout ? <Footer isEducationSite={isEducationSite} /> : <></>}
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </>
  );
};

export default memo(CompanyPageContent);
